const Events = [
  // {
  //   name: "Aqua-Innovate",
  //   link: "/AquaMOD",
  //   poster: "/img/event/AquaInnovate.png",
  //   description:
  //     "Showcase your creativity by modifying a vessel for better efficiency.",
  // },
  {
    name: "Deep Sea Disputes",
    link: "/Dispustes",
    poster: "/img/event/DeepSeaDispustes_Logo.png",
    description: "Engage in debates on ocean-related topics.",
  },
  {
    name: "Maritime Mystery",
    link: "/Treasurehunt",
    poster: "/img/event/TresureHunt_Logo.jpg",
    description:
      "Solve puzzles and uncover hidden clues in this treasure hunt.",
  },
  {
    name: "Boat Wars",
    link: "/Boatwars",
    poster: "img/event/BoatWars_Logo.png",
    description:
      "Compete in boat racing, tug of war, and waste cleaning challenges.",
  },
  {
    name: "Quizathon",
    link: "/Quizathon",
    poster: "/img/event/Quizathon_Logo.jpg",
    description: "A general knowledge quiz on ocean and naval topics.",
  },
  {
    name: "Aqua Exposure",
    link: "/Aquaexposure",
    poster: "/img/event/AquaExposure_Logo.png",
    description: "Showcase ocean engineering through original photographs.",
  },
  {
    name: "Wave Quest",
    link: "/Wavequest",
    poster: "/img/event/WaveQuest_Logo.jpg",
    description: "Solve real-world ocean engineering case studies.",
  },
  {
    name: "Paper Prep",
    link: "/PaperPrep",
    poster: "/img/event/paperprep_Logo.jpg",
    description: "Explore research and innovation in ocean studies.",
  },
];

export default Events;
